import { useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Input } from "@/components/ui/input";
import { FileDown } from "lucide-react";
import { toast } from "sonner";
import { saveGuest } from "@/lib/guest";

export default function GuestDetailsDialog({ open, onClose, onSubmit, heading, ctaLabel }) {
  const [form, setForm] = useState({ name: "", phone: "", email: "" });
  const onChange = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = (e) => {
    e?.preventDefault?.();
    if (!form.name.trim() || !form.phone.trim() || !form.email.trim()) {
      toast.error("Please share your name, phone and email");
      return;
    }
    saveGuest(form);
    onSubmit(form);
  };

  return (
    <Dialog open={open} onOpenChange={(v) => { if (!v) onClose(); }}>
      <DialogContent className="max-w-md bg-ivory border-ink/10" data-testid="guest-details-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl font-light flex items-center gap-2.5">
            <FileDown className="w-5 h-5 accent-color" />
            {heading || "Almost there — who is this quotation for?"}
          </DialogTitle>
        </DialogHeader>
        <form className="space-y-4" onSubmit={submit}>
          <DialogDescription className="text-sm text-graphite leading-relaxed">
            We&apos;ll personalise this for you and have our planner keep it ready. We ask only once — never again on this device.
          </DialogDescription>
          <Input value={form.name} onChange={onChange("name")} placeholder="Your name *" required data-testid="guest-name" />
          <Input value={form.phone} onChange={onChange("phone")} placeholder="Phone *" required data-testid="guest-phone" />
          <Input value={form.email} onChange={onChange("email")} placeholder="Email *" type="email" required data-testid="guest-email" />
          <button type="submit" className="btn-primary w-full" data-testid="guest-submit-btn">
            {ctaLabel || "Get my quotation"}
          </button>
        </form>
      </DialogContent>
    </Dialog>
  );
}
